<template>
  <div>
    <h3 v-if="state.loading">
      <content-placeholders>
        <content-placeholders-text :lines="1" />
      </content-placeholders>
    </h3>
    <b-alert v-else-if="state.error" show variant="warning">
      Error loading experts...
    </b-alert>
    <h3 v-else-if="state.data">{{ total }} Results</h3>
  </div>
</template>

<script>
export default {
  name: 'CandidateSearchResults',
  props: {
    state: {
      type: Object,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  }
}
</script>
